module.exports = __webpack_public_path__ + "static/media/liverpool.49fb318e.png";